import React, { Component } from "react";
import PropTypes from "prop-types";
import { postUrlToParent } from "../../utilities/postMessage";

class VideoCard extends Component {
  constructor(props) {
    super(props);

    this.sendUpstream = (e) => {
      postUrlToParent(e.currentTarget.href);
    };
  }
  render() {
    const { video } = this.props;
    const imgUrl =
      video.image && `${process.env.REACT_APP_BASE_URL}${video.image}`;

    const videoImg = (
      <div className="learn-video-img">
        <div className="learn-video-thumbnail-wrapper">
          <img
            src={imgUrl}
            role="presentation"
            alt=""
            className="img-responsive learn-video-thumbnail"
          />
        </div>
      </div>
    );
    const videoTitle = (
      <div className="video-title text-primary">
        <div className="title">{video.title}</div>
      </div>
    );
    const videoDescription = <p>{video.description}</p>;
    const videoLinks = (
      <div className="learn-video-links">
        {video.youtubeUrl && (
          <a
            href={video.youtubeUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${
              video?.title ? video.title : "Video Thumbnail"
            } | Watch on YouTube`}
          >
            Watch on YouTube &gt;
          </a>
        )}
        {video.channel9Url && (
          <a
            href={video.channel9Url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${
              video?.title ? video.title : "Video Thumbnail"
            } | Watch on Microsoft Learn`}
          >
            Watch on Microsoft Learn &gt;
          </a>
        )}
      </div>
    );

    return (
      <div className="col-lg-4 col-md-6 col-sm-12 learn-video-card-wrapper">
        <div className="learn-video-card">
          <a
            href={video.youtubeUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={this.sendUpstream}
            tabIndex="-1"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {videoImg}
            {videoTitle}
            {videoDescription}
          </a>
          {videoLinks}
        </div>
      </div>
    );
  }
}

VideoCard.propTypes = {
  video: PropTypes.shape({
    youtubeUrl: PropTypes.string,
    channel9Url: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  }),
};
VideoCard.defaultProps = {
  video: {
    youtubeUrl: "",
    channel9Url: "",
    image: "",
    title: "",
    description: "",
  },
};

export default VideoCard;
